import React from "react";
import ReportBuilderIndex from "../../modules/reports/components/index";
import { Modal } from "antd";

interface IProps {
    isVisibelGenerateReport: boolean;
    onCancel: () => void;
}

export function ReportBuilderModal({ isVisibelGenerateReport, onCancel }: IProps) {
    return (
        <Modal
            visible={isVisibelGenerateReport}
            onCancel={onCancel}
            footer={null}
            width="90%"
            style={{ top: 20 }}
            bodyStyle={{
                paddingTop: 50,
                border: "1px solid #ccc",
                borderTop: "none",
            }}
        >
            <ReportBuilderIndex />
        </Modal>
    );
}
